import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";

import { text } from "../text";
import { utils } from "../utils";
import { svg } from "../assets/svg";

import { theme } from "../constants";
import { selectedCity } from "../environment";

type Props = {
  title: string;
  viewAllVisible?: boolean;
  rightIcon?: React.ReactNode;
  viewAllOnClick?: () => void;
  rightIconOnClick?: () => void;
  containerStyle?: React.CSSProperties;
  /** ✅ New prop for showing a button */
  buttonVisible?: "visible" | "hide";
  /** Optional click handler for the button */
};

export const BlockHeading: React.FC<Props> = ({
  title,
  rightIcon,
  viewAllOnClick,
  containerStyle,
  rightIconOnClick,
  viewAllVisible = true,
  buttonVisible,
}) => {
  // console.log( selectedCity, "from heading" )

  // console.log(title, "title.00000");
  // console.log(viewAllVisible, "buttonVisible.00000");

  return (
    <div
      style={{
        ...utils.rowCenterSpcBtw(),
        ...containerStyle,
      }}
    >
      <text.H3
        style={{
          textTransform: "capitalize",
          ...theme.fonts.LeagueSpartan_600SemiBold,
        }}
      >
        {title}
      </text.H3>

      {viewAllVisible && viewAllOnClick && (
        <div onClick={viewAllOnClick} style={{ cursor: "pointer" }}>
          <svg.ViewAllSvg />
        </div>
      )}
    </div>
  );
};
